/* No trailing slash */
export const OauthAPIEndpoints = {
    UPDATE: 'token/update',
    VALIDATE: 'credentials/validate',
    INTROSPECT: 'token/introspect',
};
